module.exports = __webpack_public_path__ + "static/media/8797.b28e2c3b.png";